import * as React from "react";
import { styled } from "@mui/material/styles";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Research from "../../funtComponents/research";
import PopUp from "../../funtComponents/popUpAnexos";
import ExpandUser from "../../funtComponents/outgoingCalls/audioExpand";
import ListReport from "../models/listReport";
import ListOutgoing from "../../funtComponents/outgoingCalls/listOutgoing";
import { View, TitleTopBar } from "../outgoingCalls/outElements";
import { connect, useDispatch } from "react-redux";
import * as redux from "../../../redux/constanst/index";
import {
  llamadasEntrantes,
  llamadasSalientes,
  mapStateToProps,
  llamadasErrores,
  arreglo,
  formatter,
  secondsToString,
  formatearFechaPDF,
} from "../models/buscar";

import jsPDF from "jspdf";
import LoadScreen from "../loadScreen";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function SalientesPage(props) {
  const [openLoad, setOpenLoad] = React.useState(false);
  const dispatch = useDispatch();
  const [anexosState] = React.useState("Anexos");
  const [changeOptions] = React.useState("Add");

  //interactuan con el PopUp

  const resuelto = arreglo(props.salientes, props.rightAnexos);

  const handleClickOpen = (item) => {
    var generateData = function (item) {
      var result = [];
      var total = {
        total: 0,
      };
      var o = 1;
      for (var i = 0; i < Object.values(item).length; i++) {
        if (parseFloat(Object.values(item)[i].cost) > 0) {
          total.total =
            parseFloat(total.total) + parseFloat(Object.values(item)[i].cost);
          var data = {
            id: o.toString(),
            Fecha: formatearFechaPDF(Object.values(item)[i].calldate),
            Anexo: Object.values(item)[i].chan1,
            Destino: Object.values(item)[i].dst,
            Duracion: secondsToString(Object.values(item)[i].duration),
            Valor: formatter(parseFloat(Object.values(item)[i].cost)),
          };
          o++;
          result.push(Object.assign({}, data));
        } else if (Object.values(item)[i].pent) {
          total.total =
            parseFloat(total.total) + parseFloat(Object.values(item)[i].cost);
          data = {
            id: o.toString(),
            Fecha: formatearFechaPDF(Object.values(item)[i].calldate),
            Anexo: Object.values(item)[i].chan1,
            Destino: Object.values(item)[i].dst,
            Duracion: secondsToString(Object.values(item)[i].duration),
            Valor: "Pendiente",
          };
          o++;
          result.push(Object.assign({}, data));
        }
      }
      return [result, total];
    };

    function createHeaders(keys) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 10,
          align: "center",
          padding: 0,
        });
      }
      return result;
    }

    var headers = createHeaders([
      "id",
      "Fecha",
      "Anexo",
      "Destino",
      "Duracion",
      "Valor",
    ]);
    const fecha1 = `${props.dateChangeInicio.dia}/${props.dateChangeInicio.mes}/2022`;
    const fecha2 = `${props.dateChangeFinal.dia}/${props.dateChangeFinal.mes}/2022`;
    const contenTable = generateData(item);
    var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "portrait" });
    // crea un nuevo objeto `Date`
    var today = new Date();

    // obtener la fecha y la hora
    var now = today.toLocaleDateString();
    now = now.replaceAll("/", "-");

    /*
        Resultado: 1/27/2020, 9:30:00 PM
    */
    doc.text("Fecha inicio: " + fecha1, 10, 60);

    doc.text("Fecha final: " + fecha2, 10, 67);
    //

    doc.text("Total neto: " + formatter(contenTable[1].total), 10, 85);
    const img =
      "data:image/png;base64,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";
    doc.addImage(img, "JPEG", 20, 3, 70, 15);

    doc.text("RESUMEN DE LLAMADAS ", 70, 40);
    doc.setFillColor(215, 100, 100);
    doc.rect(100, 0, 200, 20, "F");
    var valoresX = 95;
    var valoresY = 105;
    var o = 0;
    doc.setPage(1);
    // eslint-disable-next-line array-callback-return
    resuelto.map((val) => {
      if (val.cost > 0) {
        function filtrarPorID(obj) {
          if (obj.chan1 === val.chan1) {
            return obj;
          }
        }
        //
        const audio = Object.values(props.salientes).filter(filtrarPorID);

        const contenTable = generateData(audio);

        doc.text("Detalle de anexo: " + val.name[0], 25, valoresX, {
          maxWidth: 1000,
        });

        doc.text("Subtotal: " + formatter(val.cost), 25, valoresX + 5, {
          maxWidth: 1000,
        });
        valoresX = valoresX + 5;
        valoresX = valoresX + 10;

        doc.table(25, valoresY, contenTable[0], headers, {
          autoSize: true,
          headerBackgroundColor: "red",
        });

        doc.addPage("a4");
        valoresX = 10;
        valoresY = 20;
      }

      if (Object.values(resuelto).length <= o) {
        o = 0;
      }
    });

    var pageCount = doc.internal.getNumberOfPages();
    doc.deletePage(pageCount);
    doc.save(`DetalleLlamadasSalientes_${props.idBuscar.name}-(${now})`);
  };

  //
  const handlerSearch = async (
    diaInicio,
    mesInicio,
    diaFinal,
    mesFinal,
    yearInicio,
    yearFinal,
    anexos
  ) => {
    
    const errores = llamadasErrores(
      "nada",
      0,
      diaInicio,
      mesInicio,
      diaFinal,
      mesFinal,
      yearInicio,
      yearFinal,
      anexos
    );
    if (typeof errores !== "number") {
      dispatch({
        type: redux.USER_ERRORSTATE_STATE_CHANGE,
        errorState: errores.mensaje,
      });
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true });
    }
    if (errores === 200) {
      await dispatch({
        type: redux.USER_SALIENTES_STATE_CHANGE,
        salientes: [],
      });

      await dispatch({
        type: redux.USER_ENTRANTES_STATE_CHANGE,
        entrantes: [],
      });
      setOpenLoad(true);
      const respEntrantes = await llamadasEntrantes(
        "entrantes",
        0,
        diaInicio,
        mesInicio,
        diaFinal,
        mesFinal,
        yearInicio,
        yearFinal,
        anexos
      );
      const respSalientes = await llamadasSalientes(
        "salientes",
        0,
        diaInicio,
        mesInicio,
        diaFinal,
        mesFinal,
        yearInicio,
        yearFinal,
        anexos
      );
      if (respSalientes?.type === "SQL" || respEntrantes?.type === "SQL") {
        handlerSearch(
          diaInicio,
          mesInicio,
          diaFinal,
          mesFinal,
          yearInicio,
          yearFinal,
          anexos
        );
        return;
      }
      await dispatch({
        type: redux.USER_SALIENTES_STATE_CHANGE,
        salientes: respSalientes,
      });

      await dispatch({
        type: redux.USER_ENTRANTES_STATE_CHANGE,
        entrantes: respEntrantes,
      });
      setOpenLoad(false);
    }
  };
  return (
    <View style={GnralContainer}>
      <View style={HeaderContain}>
        <View style={HeaderTopBar}>
          <EqualizerIcon style={IconTopBar} />
          <TitleTopBar style={TitleTopBarStyle}>Salientes</TitleTopBar>
        </View>
        {changeOptions === "Add" ? (
          <View style={SearchContain}>
            <PopUp btnText={anexosState} />
            <View style={SearchBar}>
              <Research />
            </View>
            <View style={SearchBtnContain}>
              <Button
                style={SearchBtn}
                onClick={() =>
                  handlerSearch(
                    props.dateChangeInicio.dia,
                    props.dateChangeInicio.mes,
                    props.dateChangeFinal.dia,
                    props.dateChangeFinal.mes,
                    props.dateChangeInicio.year,
                    props.dateChangeFinal.year,
                    Object.values(props.rightAnexos)
                  )
                }
                variant="contained"
                color="success"
              >
                <p style={{ fontSize: 10 }}>filtrar</p>
              </Button>
            </View>
          </View>
        ) : (
          <View style={BlankView} />
        )}
      </View>

      <View style={BodyContain}>
        <Box sx={BodyWrapper}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={5}>
              <Item>
                <ListReport />
              </Item>
            </Grid>
            <Grid item xs={5}>
              <Item>
                <ListOutgoing />
              </Item>
            </Grid>
            <Grid item xs={10}>
              <Item>
                <View style={ItemTitleBar}>
                  <h4>Llamadas Salientes (Por Usuario)</h4>
                </View>
                <div id="PDF">
                  <ExpandUser />
                </div>

                <View style={ItemExportBar}>
                  <Button
                    color="primary"
                    onClick={() => handleClickOpen(props.salientes)}
                  >
                    Exportar
                  </Button>
                </View>
              </Item>
            </Grid>
          </Grid>
        </Box>

        <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad} />
      </View>
    </View>
  );
}

export default connect(mapStateToProps, null)(SalientesPage);
const GnralContainer = {
  height: "100%",
  display: "flex",
  width: "100%",
  backgroundColor: "#f6f6f6",
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

const HeaderContain = {
  flexDirection: "row",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
};

const HeaderTopBar = {
  flexDirection: "row",
  minWidth: 150,
  width: "100%",
  display: "flex",
  flex: 1.5,
  alignItems: "center",
  justifyContent: "flex-start",
};

const IconTopBar = {
  marginLeft: 10,
  marginBottom: 10,
  color: "rgba(229, 29, 29, 0.7)",
};

const TitleTopBarStyle = {
  fontSize: 15,
  color: "rgba(229, 29, 29, 0.7)",
  alignSelf: "flex-start",
  marginLeft: 15,
  marginBottom: 10,
};

const SearchContain = {
  paddingLeft: 30,
  flexDirection: "row",
  height: "100%",
  width: "100%",
  display: "flex",
  flex: 11,
  alignItems: "center",
  justifyContent: "center",
};

const SearchBar = {
  flexDirection: "row",
  height: "100%",
  width: "100%",
  display: "flex",
  flex: 5,
  alignItems: "center",
  justifyContent: "center",
};

const SearchBtnContain = {
  display: "flex",
  flex: 2,
  flexDirection: "row",
};

const SearchBtn = {
  marginLeft: 10,
  background: "rgba(229, 29, 29, 0.7)",
};

const BlankView = {
  flexDirection: "row",
  height: "100%",
  width: "100%",
  display: "flex",
  flex: 4,
  alignItems: "center",
  justifyContent: "center",
};

const BodyContain = {
  height: "auto",
  display: "flex",
  width: "100%",
  backgroundColor: "rgba(238, 238, 238, 0.9)",
  marginTop: 10,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  padding: 10,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
};

const BodyWrapper = {
  flexGrow: 1,
  width: "100%",
  height: "100%",
};

const ItemTitleBar = {
  height: 50,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  alignContent: "center",
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20,
};

const ItemExportBar = {
  height: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  alignContent: "center",
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  paddingLeft: 20,
  paddingTop: 20,
};
